import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  container: {
    // padding: "30px",
    height: "100%",
    overflow: "scroll",
  },
}))
export default styles
